import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/base/globals.css";

import "./styles/pages/home/Statistics.css";
import "./styles/pages/home/HowItWorks.css";
import "./styles/pages/home/Audience.css";
import "./styles/pages/home/News.css";

import "./styles/pages/assignments/AssignmentBoard.css";
import "./styles/pages/assignments/AssignmentDetails.css";
import "./styles/pages/assignments/SavedJobs.css";

import "./styles/pages/ProfessionalDashboard.css";
//import "./styles/navbar.css";//

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
